<script>
  export var settings;

  import {
    Button,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Card,
    Col,
  } from "sveltestrap";
  import { Form, FormGroup, FormText, Label } from "sveltestrap";
  import Upgrade from './Upgrade.svelte'
</script>

Team memberships
<Upgrade />
Current:
{#if settings.teams.length == 0}
  None
{:else}
  {#each settings.teams as team}
    <Card body>
      Name:
      <a href={team.id}>{team.name}</a>
      <br />Description:
      {team.description}
      <br />Owner:
      {team.owner}
      <br />Rec count:
      {team.recs.length}
    </Card>
  {/each}
{/if}
Request to join:
